import React, { useEffect } from 'react';
import { saveStateAndLogin } from '../../../adapters/authentication-utils';
import './auth.css';
import { MessageSection } from '@able/react';
import { getAbleSpriteSheet } from '../../../adapters/utils';
const ableSpriteSheet = getAbleSpriteSheet();
import Parser from 'html-react-parser';

const Auth = (props) => {

    const { loginCheckInProgress, outageDisplay } = props;
    useEffect(() => {
        const button = document.getElementById('auth-button');
        if (loginCheckInProgress || outageDisplay) {
            button && button.setAttribute('disabled', true);
        }
        else button && button.removeAttribute('disabled');
    }, [loginCheckInProgress || outageDisplay]);

    const title = 'You may already have an account';
    const desc = "Sign in to skip ahead in your activation. If you're unsure if you have an account, enter your email and follow the 'recover account' prompts. <br><br> Your account could still be active even if you haven't used your service recently.";

    return (
        <div id="auth-container">
            <MessageSection
                developmentUrl={ableSpriteSheet}
                variant="Information"
                description={Parser(desc)}
                titleText={title}
                titleElement="h2"
                actionId="auth-button"
                actionCallback={()=> saveStateAndLogin()}
                actionElement="button"
                actionText="Sign in"
            />
        </div>
    );
};

export default Auth;
